<template>

	<div class="content">
		<section class="learning_detail">
			<div class="learning_head">
				<figure class="learning_thumb">
					<img v-if="eduMain.thumbnail != null && eduMain.thumbnail !== ''" :src="eduMain.thumbnail" style="object-fit: cover; aspect-ratio: 1 / 1;" :alt="eduMain.eduTitle">
					<img v-else src="/ssflex/assets/img/common/img_thumb.svg" :alt="eduMain.eduTitle">
				</figure>
				<div class="learning_text">
					<em class="cate m-r-5">
						<span class="notice_cate m-r-5" v-if="eduMain.isMajor">주요</span>
						<span v-if="!$options.filters.isEmpty(eduMain.cateCodeVO)">{{ eduMain.cateCodeVO.codeName }}</span>
					</em>
					<h2 class="tit">
						{{ eduMain.shortTitle }} {{ eduMain.eduTitle }}
					</h2>
					<div class="progress" v-if="eduStudent != null && eduStudent.isRequest">
						<div class="progress_text">
							<span>학습진행률</span>
							<span class="per">{{ completeContentCnt | avg( allContentCnt ) }}%</span>
						</div>
						<div class="progress_bar">
							<span :style="'width: ' + ( $options.filters.avg( completeContentCnt, allContentCnt )) + '%'"></span>
						</div>
					</div>

					<div class="info">
						<dl>
							<dt>일정</dt>
							<dd>{{ eduMain.startDate | scheduleFilter }} - {{ eduMain.endDate | scheduleFilter }}</dd>
						</dl>
						<dl>
							<dt>필수이수시간</dt>
							<dd>{{ eduMain.playMinutes }}분</dd>
						</dl>
					</div>


<!--						<div class="btn_wrap">
						<button type="button" class="btn btn-lg btn-dark">학습하기</button>
					</div>-->

					<!-- 교육 신청전 + 비로그인 -->
					<template v-if="eduMain != null && eduMain.emIdx > 0">
						<div class="btn_wrap" v-if=" eduStudent == null || !eduStudent.isRequest">

							<template v-if="eduMain.numLeft > 0">
								<button type="button" class="btn btn-lg btn-dark btn_learn" @click="doRequest" v-if="finishCount < eduMain.numLeft">교육신청</button>
								<button type="button" class="btn btn-lg btn-dark btn_learn" v-if="finishCount >= eduMain.numLeft">선착순 마감</button>
							</template>
							<template v-else-if="!eduMain.isDisplay || !this.isExpiryDate  ">
								<div class="btn btn-lg btn-default btn_learn" v-if="!eduMain.isDisplay">공개되지 않은 교육입니다.</div>
								<div class="btn btn-lg btn-default btn_learn" v-if="!this.isExpiryDate">교육 신청 기간이 아닙니다.</div>
							</template>
							<template v-else>
								<button type="button" class="btn btn-lg btn-dark btn_learn" @click="doRequest">교육신청</button>
							</template>

							<!--<a href="javascript:;" class="btn-like" :id="'eduWish-' + eduMain.emIdx" :data-emIdx="eduMain.emIdx" @click="setWish"><i class="ico-heart"></i>{{ eduMain.wishCount }}</a>-->
							<button type="button" class="btn btn-lg btn_like" :id="'eduWish-' + eduMain.emIdx" :data-emIdx="eduMain.emIdx" @click="setWish">{{ eduMain.wishCount }}</button>
						</div>

						<!-- 교육 진행중 -->
						<div class="btn_wrap" v-else-if="eduStudent != null && eduStudent.isRequest">
							<template v-if="!eduMain.isDisplay">
								<div class="btn btn-lg btn-default btn_learn">비공개되었습니다. 고객센터로 문의바랍니다.</div>
							</template>
							<template v-else-if="!eduStudent.isComplete && !isEnableComplete ">
								<button type="button" class="btn btn-lg btn-dark btn_learn" v-if="completeContentCnt <= 0" @click="doAnswer(eduMain.emIdx);">학습 시작하기</button>
								<button type="button" class="btn btn-lg btn-dark btn_learn" v-if="completeContentCnt > 0" @click="doAnswer(eduMain.emIdx);">학습 계속하기</button>
							</template>
							<template v-else-if="!eduStudent.isComplete && isEnableComplete ">
								<button type="button" class="btn btn-lg btn-dark btn_learn" @click="doComplete">이수 완료</button>
							</template>

							<button type="button" class="btn btn-lg btn_like"  :id="'eduWish-' + eduMain.emIdx" :data-emIdx="eduMain.emIdx" @click="setWish">{{ eduMain.wishCount }}</button>
						</div>
					</template>

				</div>
			</div>


			<div class="learning_cont">

				<!-- 비회원 or 신청전 화면 -->
				<edu-before v-if="eduStudent == null || !eduMain.isDisplay" v-bind:contentList="eduMain.contentList"></edu-before>

				<!-- 학습 신청 후 교육과정-->
				<div class="section" v-else-if="eduStudent != null && eduStudent.isRequest">
					<strong class="tit">교육과정</strong>
					<div>
						<table class="tbl_rwd">
							<thead>
							<tr>
								<th>학습내용</th>
								<th>구분</th>
								<th>학습현황</th>
								<th>학습하기</th>
							</tr>
							</thead>
							<tbody>

							<!-- 단계별 진행 -->
							<template v-if="eduMain.isStep">
								<tr v-for="(content, i) in eduMain.contentList">

									<template v-if="content.contentType === 'mov'" >
										<td data-td="학습내용" class="left">
											<template v-if="content.qstMovVO != null">
												{{content.qstMovVO.movTitle}}
											</template>
										</td>
										<td data-td="구분">동영상</td>
										<td data-td="학습현황">
											<b class="active">
												<template v-if="answerList[i] != null">
													{{ Math.floor(answerList[i].ansMovVO.currentTimes / 60) }}분
												</template>
												<template v-else>
													0분
												</template>
											</b>
											/ {{content.qstMovVO.playMinutes}}분
										</td>
										<td data-td="학습하기">
											<button type="button" class="btn_tbl" v-if="answerList[i] != null && answerList[i].isComplete"  @click="doReplay( content.emIdx, i)">다시보기</button>
										</td>
									</template>

									<template v-else-if="content.contentType === 'file'" >
										<td data-td="학습내용" class="left">{{ content.qstFileVO.fileDesc }}</td>
										<td data-td="구분">파일</td>
										<td data-td="학습현황">
											<b class="active">
												<template v-if="answerList[i] != null">
													{{ answerList[i].fileDownloadCount }}
												</template>
												<template v-else>
													0
												</template>
											</b>
											/ {{content.qstFileVO.fileList.length}}개
										</td>
										<td data-td="학습하기">
											<button type="button" class="btn_tbl" v-if="answerList[i] != null && answerList[i].isComplete"  @click="doReplay( content.emIdx, i)">다운로드</button>
										</td>
									</template>

									<template v-else-if="content.contentType === 'tst'" >
										<td data-td="학습내용" class="left">{{ content.qstTstList.length }} 문항</td>
										<td data-td="구분">테스트</td>
										<td data-td="학습현황">
											<template v-if="answerList[i] != null && answerList[i].isComplete" >
												정답율
												<b class="active">
													{{ answerList[i].tstCorrectCount | avg(answerList[i].tstSolveCount) }}%
												</b>
											</template>
											<template v-else>
												<b class="active">
													<template v-if="answerList[i] != null">
														{{ answerList[i].tstSolveCount }}
													</template>
													<template v-else>
														0
													</template>
												</b>
												/ {{content.qstTstList.length}}문항
											</template>
										</td>
										<td data-td="학습하기">
											<button type="button" class="btn_tbl" v-if="answerList[i] != null && answerList[i].isComplete" @click="doRestart( content.emIdx, i, answerList[i])">재시험</button>
										</td>
									</template>

									<template v-else-if="content.contentType === 'wait'" >
										<td data-td="학습내용" class="left">준비중</td>
										<td data-td="구분">미정</td>
										<td data-td="학습현황"></td>
									</template>

								</tr>
							</template>

							<!-- 임의 진행 -->
							<template v-else>
								<tr v-for="(content, i) in eduMain.contentList">

									<template v-if="content.contentType === 'mov'" >
										<td data-td="학습내용" class="left">
											<template v-if="content.qstMovVO != null">
												{{content.qstMovVO.movTitle}}
											</template>
										</td>
										<td data-td="구분">동영상</td>
										<td data-td="학습현황">
											<b class="active">
												<template v-if="answerList[i] != null">
													{{ Math.floor(answerList[i].ansMovVO.currentTimes / 60) }}분
												</template>
												<template v-else>
													0분
												</template>
											</b>
											/ {{content.qstMovVO.playMinutes}}분
										</td>
										<td data-td="학습하기">
											<button type="button" class="btn_tbl" v-if="answerList[i] != null && !answerList[i].isComplete" @click="doAnswer( content.emIdx, i, answerList[i])">학습하기</button>
											<button type="button" class="btn_tbl" v-else-if="answerList[i] != null && answerList[i].isComplete" @click="doReplay( content.emIdx, i, answerList[i])">다시보기</button>
										</td>
									</template>

									<template v-else-if="content.contentType === 'file'" >
										<td data-td="학습내용" class="left">{{ content.qstFileVO.fileDesc }}</td>
										<td data-td="구분">파일</td>
										<td data-td="학습현황">
											<b class="active">
												<template v-if="answerList[i] != null">
													{{ answerList[i].fileDownloadCount }}
												</template>
												<template v-else>
													0
												</template>
											</b>
											/ {{content.qstFileVO.fileList.length}}개
										</td>
										<td data-td="학습하기">
											<button type="button" class="btn_tbl" v-if="answerList[i] != null && !answerList[i].isComplete" @click="doAnswer( content.emIdx, i, answerList[i])">다운로드</button>
											<button type="button" class="btn_tbl" v-else-if="answerList[i] != null && answerList[i].isComplete" @click="doReplay( content.emIdx, i, answerList[i])">다운로드</button>
										</td>
									</template>

									<template v-else-if="content.contentType === 'tst'" >
										<td data-td="학습내용" class="left">{{ content.qstTstList.length }} 문항</td>
										<td data-td="구분">테스트</td>
										<td data-td="학습현황">

											<template v-if="answerList[i] != null && answerList[i].isComplete" >
												정답율
												<b class="active">
													{{ answerList[i].tstCorrectCount | avg(answerList[i].tstSolveCount) }}%
												</b>
											</template>
											<template v-else>
												<b class="active">
													<template v-if="answerList[i] != null">
														{{ answerList[i].tstSolveCount }}
													</template>
													<template v-else>
														0
													</template>
												</b>
												/ {{content.qstTstList.length}}문항
											</template>
										</td>
										<td data-td="학습하기">
											<template v-if="answerList[i] != null && answerList[i].isComplete" >
												<button type="button" class="btn_tbl" @click="doRestart( content.emIdx, i, answerList[i])">재시험</button>
											</template>
											<template v-else>
												<button type="button" class="btn_tbl" @click="doAnswer( content.emIdx, i)">테스트</button>
											</template>
										</td>
									</template>

									<template v-else-if="content.contentType === 'wait'" >
										<td data-td="학습내용" class="left">준비중</td>
										<td data-td="구분">미정</td>
										<td data-td="학습현황"></td>
									</template>

								</tr>
							</template>

							</tbody>
						</table>
					</div>
				</div>


				<!-- 비회원 or 신청전 화면 --><!--				<div class="section" v-else>
					&lt;!&ndash; 학습 신청 전 교육과정&ndash;&gt;
					<strong class="tit">교육과정</strong>
					<div>
						<table class="tbl_rwd">
							<thead>
							<tr>
								<th>학습내용</th>
								<th>구분</th>
							</tr>
							</thead>
							<tbody>
							<tr v-for="(content, i) in eduMain.contentList">
								<td data-td="학습내용" class="left">
									<template v-if="content.contentType === 'mov'" >
										<template v-if="content.qstMovVO != null">
											{{content.qstMovVO.movTitle}}
										</template>
									</template>
									<template v-if="content.contentType === 'file'" >
										{{ content.qstFileVO.fileDesc }}
									</template>
									<template v-if="content.contentType === 'tst'" >
										테스트 {{ content.qstTstList.length }} 문항
									</template>
								</td>
								<td data-td="구분">
									<template v-if="content.contentType === 'mov'" >동영상</template>
									<template v-if="content.contentType === 'file'" >파일</template>
									<template v-if="content.contentType === 'tst'" >테스트</template>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>-->




				<div class="section">
					<strong class="tit">개요</strong>
					<div class="overflow" v-html="eduMain.introduce"></div>
				</div>
				<div class="section">
					<strong class="tit">목표</strong>
					<div v-html="eduMain.goal"></div>
				</div>
				<div class="section">
					<strong class="tit">강사</strong>
					<div>
						{{ eduMain.teachName }}
					</div>
				</div>
<!--					<div class="section">
					<strong class="tit">수료기준</strong>
					<div>
						<table class="tbl_rwd">
							<thead>
							<tr>
								<th>학습내용</th>
								<th>수료기준</th>
							</tr>
							</thead>
							<tbody>
							<tr>
								<td data-td="학습내용" class="left">BIM Data를 응용한 Dynamo 실무 적용 사례_Revit MEP편</td>
								<td data-td="수료기준">동영상 재생완료</td>
							</tr>
							<tr>
								<td data-td="학습내용" class="left">BIM Data를 응용한 Dynamo 실무 적용 사례_Revit Architecture 편</td>
								<td data-td="수료기준">동영상 재생완료</td>
							</tr>
							<tr>
								<td data-td="학습내용" class="left">알쓸다잡 ; 알아두면 쓸모있는 다이나모의 잡다한 기능</td>
								<td data-td="수료기준">동영상 재생완료</td>
							</tr>
							<tr>
								<td data-td="학습내용" class="left">필수 이수시간</td>
								<td data-td="수료기준">총 90분</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>-->
			</div>
		</section>
		<!-- //learning modal -->
		<div class="btn_wrap" style="text-align: center; margin-top: 30px;">
			<button type="button" class="btn btn-lg btn-dark btn_learn" @click="goBackList">목록으로</button>
		</div>
	</div>

</template>

<script>
import Qs from "qs";
import eduBefore from "@/cs1/components/educations/main/eduBefore";
export default {
	name: "eduLearning",
	components: {eduBefore},
	prop: {
		emIdx: Number,
	},
	data() {

		const userId = this.getLoginId()

		return {

			userId,

			emIdx: this.$route.query.emIdx,
			eduMain: new this.EduMainVO(),
			eduContentList: new Array(new this.EduContentVO()),
			eduStudent: new this.EduStudentVO(),
			answerList: new Array( new this.EduAnswerVO() ),


			// 전체 컨텐츠 수, 이수한 컨텐츠 수
			allContentCnt: 0,
			completeContentCnt: 0,

			// 완료처리 가능여부
			isEnableComplete: true,

			// 현재 신청 + 완료자 수
			finishCount: 0,

			// 수료기준 텍스트
			completeText: [],

			// 교육기간이 유효한지
			isExpiryDate : true,
		}
	},
	created() {

		this.getEduMain( this.emIdx, this.userId );

		window.eduView = this
	},
	mounted() {

		//this.getWishLike( this.emIdx, this.userId );

	},
	updated() {

		this.$nextTick(() => {
			this.getWishLike( this.emIdx, this.userId );
		})
	},
	methods: {


		getStudent: function ( emIdx, userId ) {

			var self = this;
			self.completeContentCnt = 0;

			self.$eventBus.$emit("startProgress", 1)
			this.axiosCaller.get(  this, this.APIs.EDU_STUDENT + "/", {
				emIdx: emIdx,
				userId: userId,
			}, function (res) {
				self.$eventBus.$emit("doneProgress", 1)

				const result = res.data
				//console.log(result)

				if ( result.status === "ok" ) {
					self.eduStudent = result.eduStudentVO;
					self.answerList = result.answerList;

					/**
					 * 사용자의 이수 컨텐츠 합
					 */
					var index = 0;
					self.answerList.forEach(ans => {

						if ( !ans.isComplete ) {
							self.isEnableComplete = false
						}

						if ( ans.contentType === 'tst' ) {
							self.completeContentCnt += ans.tstSolveCount;
						} else if ( ans.contentType === 'mov' ) {

							if ( ans.isComplete || Math.floor(ans.ansMovVO.currentTimes / 60) >= self.eduMain.contentList[index].qstMovVO.playMinutes ) {
								/**
								 * 영상이수완료 or 플레이시간이 필수플레이 시간보다 많을 경우
								 */
								self.completeContentCnt += self.eduMain.contentList[index].qstMovVO.playMinutes
							} else {
								/**
								 * 플레이 시간을 분단위로 추가
								 * @type {number}
								 */
								self.completeContentCnt += Math.floor(ans.ansMovVO.currentTimes / 60);
							}
						} else if ( ans.contentType === 'file' ) {
							if ( ans.isComplete ) {
								self.completeContentCnt += self.eduMain.contentList[index].qstFileVO.fileList.length;
							} else {
								self.completeContentCnt += ans.fileDownloadCount;
							}
						}
						index++;
					})

					//console.log("self.completeContentCnt ::::: " + self.completeContentCnt);
				} else {
					console.log(result.msg)
				}
				self.$eventBus.$emit("doneProgress", 2)
			})

		},


		getEduMain: function (_emIdx, _userId) {

			var self = this

			self.$eventBus.$emit("startProgress")
			this.axiosCaller.get(this, this.APIs.EDU_MAIN + "/getEduMain", {
				emIdx : _emIdx,
				userId : _userId,
			}, function (res) {
				self.$eventBus.$emit("doneProgress")

				const result = res.data
				console.log(result)
				if ( result.status === "ok" ) {

					self.eduMain = result.eduMain

					// 현재 신청자 + 완료자 합계산
					self.finishCount = self.eduMain.requestCount + self.eduMain.completeCount;

					self.eduMain.playMinutes = 0;
					self.allContentCnt = 0;

					self.completeText = []
					self.eduMain.contentList.forEach(cv => {

						// 교육 컨텐츠의 개수 합 + 기타 표출용 텍스트 정의
						if ( cv.contentType === 'tst' ) {

							self.eduMain.isTest = true;
							self.eduMain.isTestTxt = "있음";
							self.allContentCnt += cv.qstTstList.length;

							// 수료기준 : 문제풀이
							if (self.completeText.indexOf("문제풀이") < 0) {
								self.completeText.push( "문제풀이" );
							}

						} else if ( cv.contentType === 'mov' ) {

							if(cv.qstMovVO == null){
								alert("교육 구성이 진행중입니다.")
								history.back();
								return
							}

							self.eduMain.playMinutes += cv.qstMovVO.playMinutes;
							self.allContentCnt += cv.qstMovVO.playMinutes;

							// 수료기준 : 동영상 재생완료
							if (self.completeText.indexOf("동영상 재생") < 0) {
								self.completeText.push( "동영상 재생" );
							}

						} else if ( cv.contentType === 'file' ) {

							if(cv.qstFileVO == null){
								history.back();
								return
							}

							self.allContentCnt += cv.qstFileVO.fileList.length;

							// 수료기준 : 자료 내려받기
							if (self.completeText.indexOf("자료 내려받기") < 0) {
								self.completeText.push( "자료 내려받기" );
							}
						} else if ( cv.contentType === 'wait' ) {

							self.allContentCnt += 1;

							// 준비중 컨텐츠 포함
							if (self.completeText.indexOf("준비중") < 0) {
								self.completeText.push( "준비중" );
							}
						}

						self.eduMain.introduce = self.$options.filters.nl2br(self.eduMain.introduce);
						self.eduMain.goal = self.$options.filters.nl2br(self.eduMain.goal);

						// 교육항목 저장
						self.eduContentList = self.eduMain.contentList

						// self.fadeIn('.__pop.createResult')

						// 현재 교육 관심, 좋아요 조회
						//self.getWishLike( self.emIdx, self.userId );

					})

					self.getStudent( self.emIdx, self.userId );

					/*기간 내 유효한 교육인지 확인 */
					let getDateIs = new Date()
					var nowDateIs = new Date(getDateIs.getFullYear() +"-"+(getDateIs.getMonth()+1) +"-"+ getDateIs.getDate())

					if(self.eduMain.startDate != null && self.eduMain.startDate !== "" ){
						var startDateIs = new Date(self.$options.filters.scheduleFilter( self.eduMain.startDate))
						if(startDateIs > nowDateIs ){
							self.isExpiryDate = false
						}
					}
					if(self.eduMain.endDate != null && self.eduMain.endDate !== "" ){
						var endDateIs = new Date(self.$options.filters.scheduleFilter( self.eduMain.endDate))
						if( nowDateIs > endDateIs ){
							self.isExpiryDate = false
						}
					}

				}

				//console.log("allContentCnt ::::: " + self.allContentCnt)
			})

		},


		async doRequest () {

			if ( !await this.requireLogin(this) ) {
				return
			}


			this.swalUtils.fire(this.eduMain.eduTitle, "교육을 이수시작하시겠습니까?", "info", true )
				.then( (result) => {

					if ( result.isConfirmed ) {

						var self = this
						self.$eventBus.$emit("startProgress", 2)
						this.axiosCaller.put(this, this.APIs.EDU_STUDENT + "/request", {
							emIdx: this.eduMain.emIdx,
							userId: this.getLoginId(),
						}, function (res) {
							self.$eventBus.$emit("doneProgress", 2)

							const result = res.data
							//console.log(result)

							self.$eventBus.$emit("doneProgress")
							if ( result.status === "ok" ) {
								self.swalUtils.gritter( self.eduMain.eduTitle, "교육 이수 시작합니다.", "info", 1500 )
									.then(() => {
										location.reload()
									})
								/*alert( "교육 이수 시작합니다." );
								location.reload()*/
							} else {

								if ( result.msg === "no_target" ) {
									self.swalUtils.gritter( "공개교육이 아닙니다.", "죄송합니다. 교육대상이 아닙니다.", "info", 1500 )
									return;
								}
							}
						})

					}
				})

		},


		/**
		 * 학습 시작하기
		 * @param emIdx
		 * @param step
		 */
		doAnswer (emIdx, step = null) {

			let url = this.APIs.FRONT_URL + "/app/education/proceed/" + emIdx + "/" + btoa(this.getLoginId()) + "/?isLayout=false";
			if ( step != null ) {
				url += "&playStep=" + step;
			}

			const temp = {
				url: url,
				target: "proceed",
				isLayout: false,
				isCloseBTN: "Y",
			}

			this.appOpen( temp );
		},


		/**
		 * 다시보기
		 * @param emIdx
		 * @param index
		 */
		doReplay: function (emIdx, step) {

			let url = this.APIs.FRONT_URL + "/app/education/proceed/" + emIdx + "/" + btoa(this.getLoginId()) + "/?isReplay=true&isLayout=false&playStep=" + step;

			const temp = {
				url: url,
				target: "proceed",
				isLayout: false,
				isCloseBTN: "Y",
			}
			this.appOpen( temp );
		},


		/**
		 * 교육 재시작
		 * @param emIdx
		 * @param step
		 * @param _answerVO
		 */
		doRestart (emIdx, step = null, _answerVO = null) {

			const self = this

			/**
			 * 답변데이터가 있을 경우 삭제후 재시작 여부 확인
			 */
			if ( _answerVO != null && _answerVO.isComplete ) {

				self.swalUtils.fire("교육 재시작", "교육 이수기록을 삭제하고 다시 시작하시겠습니까?", "warning",true)
					.then((confirm) => {

						if ( confirm.isConfirmed ) {
							self.axiosCaller.delete(self, self.APIs.EDU_ANSWER + "/" + _answerVO.ecIdx + "/" + _answerVO.userId, {},(res) => {

								const result = res.data;
								if ( result.status === true ) {
									self.doAnswer(emIdx, step)
								} else {
									self.swalUtils.gritter(result.status, result.msg, "error")
								}
							})
						}
					})
			}
		},



		/**
		 * 수동 학습완료 처리
		 */
		doComplete: function () {

			const self = this

			/**
			 * 준비중인 컨텐츠가 있을 경우 안내후 닫기
			 */
			if ( self.eduMain.contentList.length > self.answerList.length ) {

				self.swalUtils.gritter( "다음 강의는 준비중입니다.", "다음 강의는 준비중입니다. <br />다음 강의 오픈시 알려드리겠습니다.", "info" )
				return;
			}

			self.$eventBus.$emit("startProgress", 2)
			this.axiosCaller.put(this, this.APIs.EDU_STUDENT + "/complete", {
				emIdx: this.eduMain.emIdx,
				userId: this.getLoginId(),
			}, function (result) {
				self.$eventBus.$emit("doneProgress", 2)

				self.swalUtils.gritter( "교육완료", "교육 이수가 완료되었습니다.", "info")
					.then(() => {
						location.reload()
					})
			})

		},


		goBackList(e) {
			this.$emit("goList");
			// history.back();
		},


		/**
		 * 좋아요, 찜하기 조회
		 * @param _emIdx
		 * @param _userId
		 */
		getWishLike ( _emIdx, _userId ) {

			const self = this
			self.$eventBus.$emit("startProgress", 2)
			this.axiosCaller.get( this, this.APIs.EDU_MINE + "/getWishLike", {
				emIdx: _emIdx,
				userId: _userId,
			}, function (res) {
				self.$eventBus.$emit("doneProgress", 2)

				const result = res.data;
				console.log("== getWishLike ==")
				console.log(result)

				if ( result.status === "ok" ) {

					// 상세에서 사용
					if ( result.wishVO !== null ) {
						document.querySelector('#eduWish-' + result.wishVO.emIdx).classList.add("active");
						//$('#eduWish-' + result.wishVO.emIdx).addClass("active");
					}
					if ( result.likeVO !== null ) {
						document.querySelector('#eduLike-' + result.likeVO.emIdx).classList.add("active");
						//$('#eduLike-' + result.likeVO.emIdx).addClass("active");
					}

					// 목록에서 사용
					if ( result.wishList !== null ) {
						result.wishList.forEach(wish => {
							$('#eduWish-' + wish.emIdx).addClass("active");
						})
					}
					if ( result.likeList !== null ) {
						result.likeList.forEach(like => {
							$('#eduLike-' + like.emIdx).addClass("active");
						})
					}

				} else {
					console.log(result.msg)
				}

			})

		},



		async setLike (e) {

			if ( await this.requireLogin(this) ) {

				var emIdx = this.emIdx;
				var userId = this.getLoginId();

				if ( !e.target.classList.contains("active") ) {
					this.putLike( emIdx, userId );
					e.target.classList.add("active");
					this.swalUtils.gritter( "추천", "추천 되었습니다.", "info", 800 )
				} else {
					this.deleteLike( emIdx, userId );
					e.target.classList.remove("active");
					this.swalUtils.gritter( "추천", "추천 취소되었습니다.", "info", 800 )
				}
			}

		},

		// DONE : 찜, 좋아요 유틸 추가
		// DONE : tags : eduLike-' + eduMain.emIdx || eduWish-' + eduMain.emIdx
		async setWish (e) {

			if ( await this.requireLogin(this) ) {

				var emIdx = this.emIdx;
				var userId = this.getLoginId();

				if ( !e.target.classList.contains("active") ) {
					this.putWish( emIdx, userId );
					document.querySelector('#eduWish-' + emIdx).classList.add("active");
					this.swalUtils.gritter( "관심교육", "관심교육으로 등록되었습니다.", "info", 800 )
				} else {
					this.deleteWish( emIdx, userId );
					document.querySelector('#eduWish-' + emIdx).classList.remove("active");
					this.swalUtils.gritter( "관심교육", "관심교육이 해제되었습니다.", "info", 800 )
				}
			}

		},




		putWish: function ( _emIdx, _userId ) {

			const self = this
			self.$eventBus.$emit("startProgress", 3)
			this.axiosCaller.put( this, this.APIs.EDU_MINE + "/wish", {
				emIdx: _emIdx,
				userId: _userId
			}, function (res) {
				self.$eventBus.$emit("doneProgress", 3)

				const result = res.data;
				console.log("== putWish ==")
				console.log(result)
				self.getEduMain(_emIdx, _userId);
			})

		},

		deleteWish: function ( _emIdx, _userId ) {

			const self = this
			self.$eventBus.$emit("startProgress", 3)
			this.axiosCaller.delete( this, this.APIs.EDU_MINE + "/wish", {
				emIdx: _emIdx,
				userId: _userId
			}, function (res) {
				self.$eventBus.$emit("doneProgress", 3)

				const result = res.data;
				console.log("== deleteWish ==")
				console.log(result)
				self.getEduMain(_emIdx, _userId);
			})
		},


		putLike: function ( _emIdx, _userId ) {

			const self = this
			self.$eventBus.$emit("startProgress", 3)
			this.axiosCaller.put( this, this.APIs.EDU_MINE + "/like", {
				emIdx: _emIdx,
				userId: _userId
			}, function (res) {
				self.$eventBus.$emit("doneProgress", 3)

				const result = res.data;
				console.log("== putLike ==")
				console.log(result)
				self.getEduMain(_emIdx, _userId);
				//self.eduMain.likeCount = result.counts.likeCount
			})

		},


		deleteLike: function ( _emIdx, _userId ) {

			const self = this
			self.$eventBus.$emit("startProgress", 3)
			this.axiosCaller.delete( this, this.APIs.EDU_MINE + "/like", {
				emIdx: _emIdx,
				userId: _userId
			}, function (res) {
				self.$eventBus.$emit("doneProgress", 3)

				const result = res.data;
				console.log("== deleteLike ==")
				console.log(result)
				self.getEduMain(_emIdx, _userId);
				//self.eduMain.likeCount = result.counts.likeCount
			})

		},

	}
}
</script>

<style scoped>

</style>
